// Generated by scripts/build-assets.ts from art/. Do not edit; run `pnpm assets`.
import type { AssetTree, ImageAsset } from './types';
import backgroundsCommandCenterLandscape from './backgrounds/command-center-landscape.webp';
import backgroundsCommandCenterPortrait from './backgrounds/command-center-portrait.webp';
import backgroundsElevatorLandscape from './backgrounds/elevator-landscape.webp';
import backgroundsElevatorPortrait from './backgrounds/elevator-portrait.webp';
import backgroundsHqHall from './backgrounds/hq-hall.webp';
import backgroundsIntroRoomLandscape from './backgrounds/intro/room-landscape.webp';
import backgroundsIntroRoomPortrait from './backgrounds/intro/room-portrait.webp';
import backgroundsLabLandscapeBokeh from './backgrounds/lab-landscape-bokeh.webp';
import backgroundsLabLandscape from './backgrounds/lab-landscape.webp';
import backgroundsLabPortraitBokeh from './backgrounds/lab-portrait-bokeh.webp';
import backgroundsLabPortrait from './backgrounds/lab-portrait.webp';
import brandEmblem from './brand/emblem.webp';
import brandLogo from './brand/logo.webp';
import charactersAgentAlexConfide from './characters/agent-alex/confide.webp';
import charactersAgentAlexHopeful from './characters/agent-alex/hopeful.webp';
import charactersAgentAlexNotebook from './characters/agent-alex/notebook.webp';
import charactersAgentAlexPresent from './characters/agent-alex/present.webp';
import charactersAgentAlexRrr from './characters/agent-alex/rrr.webp';
import charactersAgentAlexSheepish from './characters/agent-alex/sheepish.webp';
import charactersAgentAlexTry from './characters/agent-alex/try.webp';
import charactersAgentAlexWave from './characters/agent-alex/wave.webp';
import charactersAgentAlexWhisper from './characters/agent-alex/whisper.webp';
import charactersAgentAlexWorried from './characters/agent-alex/worried.webp';
import charactersAgentBuilderBackBackpackFront from './characters/agent-builder/back/backpack-front.webp';
import charactersAgentBuilderBackBackpack from './characters/agent-builder/back/backpack.webp';
import charactersAgentBuilderBackCapeFront from './characters/agent-builder/back/cape-front.webp';
import charactersAgentBuilderBackCape from './characters/agent-builder/back/cape.webp';
import charactersAgentBuilderBackJetpackFront from './characters/agent-builder/back/jetpack-front.webp';
import charactersAgentBuilderBackJetpack from './characters/agent-builder/back/jetpack.webp';
import charactersAgentBuilderBodyABrown from './characters/agent-builder/body/a-brown.webp';
import charactersAgentBuilderBodyADeep from './characters/agent-builder/body/a-deep.webp';
import charactersAgentBuilderBodyALight from './characters/agent-builder/body/a-light.webp';
import charactersAgentBuilderBodyAMedium from './characters/agent-builder/body/a-medium.webp';
import charactersAgentBuilderBodyAPorcelain from './characters/agent-builder/body/a-porcelain.webp';
import charactersAgentBuilderBodyATan from './characters/agent-builder/body/a-tan.webp';
import charactersAgentBuilderBodyBBrown from './characters/agent-builder/body/b-brown.webp';
import charactersAgentBuilderBodyBDeep from './characters/agent-builder/body/b-deep.webp';
import charactersAgentBuilderBodyBLight from './characters/agent-builder/body/b-light.webp';
import charactersAgentBuilderBodyBMedium from './characters/agent-builder/body/b-medium.webp';
import charactersAgentBuilderBodyBPorcelain from './characters/agent-builder/body/b-porcelain.webp';
import charactersAgentBuilderBodyBTan from './characters/agent-builder/body/b-tan.webp';
import charactersAgentBuilderBodyCBrown from './characters/agent-builder/body/c-brown.webp';
import charactersAgentBuilderBodyCDeep from './characters/agent-builder/body/c-deep.webp';
import charactersAgentBuilderBodyCLight from './characters/agent-builder/body/c-light.webp';
import charactersAgentBuilderBodyCMedium from './characters/agent-builder/body/c-medium.webp';
import charactersAgentBuilderBodyCPorcelain from './characters/agent-builder/body/c-porcelain.webp';
import charactersAgentBuilderBodyCTan from './characters/agent-builder/body/c-tan.webp';
import charactersAgentBuilderBodyDBrown from './characters/agent-builder/body/d-brown.webp';
import charactersAgentBuilderBodyDDeep from './characters/agent-builder/body/d-deep.webp';
import charactersAgentBuilderBodyDLight from './characters/agent-builder/body/d-light.webp';
import charactersAgentBuilderBodyDMedium from './characters/agent-builder/body/d-medium.webp';
import charactersAgentBuilderBodyDPorcelain from './characters/agent-builder/body/d-porcelain.webp';
import charactersAgentBuilderBodyDTan from './characters/agent-builder/body/d-tan.webp';
import charactersAgentBuilderBodyEBrown from './characters/agent-builder/body/e-brown.webp';
import charactersAgentBuilderBodyEDeep from './characters/agent-builder/body/e-deep.webp';
import charactersAgentBuilderBodyELight from './characters/agent-builder/body/e-light.webp';
import charactersAgentBuilderBodyEMedium from './characters/agent-builder/body/e-medium.webp';
import charactersAgentBuilderBodyEPorcelain from './characters/agent-builder/body/e-porcelain.webp';
import charactersAgentBuilderBodyETan from './characters/agent-builder/body/e-tan.webp';
import charactersAgentBuilderEyewearGlasses from './characters/agent-builder/eyewear/glasses.webp';
import charactersAgentBuilderEyewearGoggles from './characters/agent-builder/eyewear/goggles.webp';
import charactersAgentBuilderEyewearMask from './characters/agent-builder/eyewear/mask.webp';
import charactersAgentBuilderEyewearShades from './characters/agent-builder/eyewear/shades.webp';
import charactersAgentBuilderHairAfro from './characters/agent-builder/hair/afro.webp';
import charactersAgentBuilderHairBob from './characters/agent-builder/hair/bob.webp';
import charactersAgentBuilderHairBraids from './characters/agent-builder/hair/braids.webp';
import charactersAgentBuilderHairBun from './characters/agent-builder/hair/bun.webp';
import charactersAgentBuilderHairCurls from './characters/agent-builder/hair/curls.webp';
import charactersAgentBuilderHairLong from './characters/agent-builder/hair/long.webp';
import charactersAgentBuilderHairPonytail from './characters/agent-builder/hair/ponytail.webp';
import charactersAgentBuilderHairShort from './characters/agent-builder/hair/short.webp';
import charactersAgentBuilderHairSpiky from './characters/agent-builder/hair/spiky.webp';
import charactersAgentBuilderHairTwists from './characters/agent-builder/hair/twists.webp';
import charactersAgentBuilderHeadgearBeanieCover from './characters/agent-builder/headgear/beanie-cover.webp';
import charactersAgentBuilderHeadgearBeanie from './characters/agent-builder/headgear/beanie.webp';
import charactersAgentBuilderHeadgearCapCover from './characters/agent-builder/headgear/cap-cover.webp';
import charactersAgentBuilderHeadgearCap from './characters/agent-builder/headgear/cap.webp';
import charactersAgentBuilderHeadgearHeadset from './characters/agent-builder/headgear/headset.webp';
import charactersAgentBuilderShoesBoots from './characters/agent-builder/shoes/boots.webp';
import charactersAgentBuilderShoesSneakers from './characters/agent-builder/shoes/sneakers.webp';
import charactersAgentBuilderSuitField from './characters/agent-builder/suit/field.webp';
import charactersAgentBuilderSuitHoodie from './characters/agent-builder/suit/hoodie.webp';
import charactersAgentBuilderSuitLabcoat from './characters/agent-builder/suit/labcoat.webp';
import charactersAgentBuilderSuitStealth from './characters/agent-builder/suit/stealth.webp';
import charactersAgentBuilderSuitTech from './characters/agent-builder/suit/tech.webp';
import charactersAgentRookDisguised from './characters/agent-rook/disguised.webp';
import charactersAgentRookRevealed from './characters/agent-rook/revealed.webp';
import charactersAgentStanding from './characters/agent/standing.webp';
import charactersCipherCatDisguised from './characters/cipher-cat/disguised.webp';
import charactersCipherCatRevealed from './characters/cipher-cat/revealed.webp';
import charactersEchoLynxDisguised from './characters/echo-lynx/disguised.webp';
import charactersEchoLynxRevealed from './characters/echo-lynx/revealed.webp';
import charactersHelperBunnyClipboard from './characters/helper-bunny/clipboard.webp';
import charactersHelperBunnyTablet from './characters/helper-bunny/tablet.webp';
import charactersMistyMoleDisguised from './characters/misty-mole/disguised.webp';
import charactersMistyMoleRevealed from './characters/misty-mole/revealed.webp';
import charactersNovaOwlDisguised from './characters/nova-owl/disguised.webp';
import charactersNovaOwlRevealed from './characters/nova-owl/revealed.webp';
import charactersScoutCelebrating from './characters/scout/celebrating.webp';
import charactersScoutListening from './characters/scout/listening.webp';
import charactersScoutReceiving from './characters/scout/receiving.webp';
import charactersShadowFoxDisguised from './characters/shadow-fox/disguised.webp';
import charactersShadowFoxHappy from './characters/shadow-fox/happy.webp';
import coachL from './coach/l.webp';
import coachMouthTeeth from './coach/mouth-teeth.webp';
import coachMouth from './coach/mouth.webp';
import coachRBunched from './coach/r-bunched.webp';
import coachRRetroflex from './coach/r-retroflex.webp';
import coachTongueSides from './coach/tongue-sides.webp';
import coachW from './coach/w.webp';
import objectsElevatorCab from './objects/elevator-cab.webp';
import objectsTargetWordsAcorn from './objects/target-words/acorn.webp';
import objectsTargetWordsBeard from './objects/target-words/beard.webp';
import objectsTargetWordsChandelier from './objects/target-words/chandelier.webp';
import objectsTargetWordsCheer from './objects/target-words/cheer.webp';
import objectsTargetWordsCodeCard from './objects/target-words/code-card.webp';
import objectsTargetWordsCrab from './objects/target-words/crab.webp';
import objectsTargetWordsCrown from './objects/target-words/crown.webp';
import objectsTargetWordsDinosaur from './objects/target-words/dinosaur.webp';
import objectsTargetWordsDrum from './objects/target-words/drum.webp';
import objectsTargetWordsFire from './objects/target-words/fire.webp';
import objectsTargetWordsFrog from './objects/target-words/frog.webp';
import objectsTargetWordsGrapes from './objects/target-words/grapes.webp';
import objectsTargetWordsGuitar from './objects/target-words/guitar.webp';
import objectsTargetWordsPopcorn from './objects/target-words/popcorn.webp';
import objectsTargetWordsRabbit from './objects/target-words/rabbit.webp';
import objectsTargetWordsRadio from './objects/target-words/radio.webp';
import objectsTargetWordsRain from './objects/target-words/rain.webp';
import objectsTargetWordsRainbow from './objects/target-words/rainbow.webp';
import objectsTargetWordsRat from './objects/target-words/rat.webp';
import objectsTargetWordsRed from './objects/target-words/red.webp';
import objectsTargetWordsRhino from './objects/target-words/rhino.webp';
import objectsTargetWordsRice from './objects/target-words/rice.webp';
import objectsTargetWordsRing from './objects/target-words/ring.webp';
import objectsTargetWordsRobin from './objects/target-words/robin.webp';
import objectsTargetWordsRobot from './objects/target-words/robot.webp';
import objectsTargetWordsRocket from './objects/target-words/rocket.webp';
import objectsTargetWordsRocks from './objects/target-words/rocks.webp';
import objectsTargetWordsRope from './objects/target-words/rope.webp';
import objectsTargetWordsSquare from './objects/target-words/square.webp';
import objectsTargetWordsStar from './objects/target-words/star.webp';
import objectsTargetWordsTornado from './objects/target-words/tornado.webp';
import objectsTargetWordsTrain from './objects/target-words/train.webp';
import objectsTargetWordsVampire from './objects/target-words/vampire.webp';
import propsHoloProjector from './props/holo-projector.webp';
import uiButtonsBack from './ui/buttons/back.webp';
import uiButtonsMicIdle from './ui/buttons/mic-idle.webp';
import uiButtonsMicListening from './ui/buttons/mic-listening.webp';
import uiButtonsSettings from './ui/buttons/settings.webp';

export const assets = {
  backgrounds: {
    commandCenterLandscape: { url: backgroundsCommandCenterLandscape, width: 1672, height: 941 },
    commandCenterPortrait: { url: backgroundsCommandCenterPortrait, width: 941, height: 1672 },
    elevatorLandscape: { url: backgroundsElevatorLandscape, width: 1672, height: 941 },
    elevatorPortrait: { url: backgroundsElevatorPortrait, width: 941, height: 1672 },
    hqHall: { url: backgroundsHqHall, width: 941, height: 1672 },
    intro: {
      roomLandscape: { url: backgroundsIntroRoomLandscape, width: 1672, height: 941 },
      roomPortrait: { url: backgroundsIntroRoomPortrait, width: 941, height: 1672 },
    },
    labLandscapeBokeh: { url: backgroundsLabLandscapeBokeh, width: 1672, height: 941 },
    labLandscape: { url: backgroundsLabLandscape, width: 1672, height: 941 },
    labPortraitBokeh: { url: backgroundsLabPortraitBokeh, width: 941, height: 1672 },
    labPortrait: { url: backgroundsLabPortrait, width: 941, height: 1672 },
  },
  brand: {
    emblem: { url: brandEmblem, width: 1400, height: 537 },
    logo: { url: brandLogo, width: 1400, height: 244 },
  },
  characters: {
    agentAlex: {
      confide: { url: charactersAgentAlexConfide, width: 864, height: 1504 },
      hopeful: { url: charactersAgentAlexHopeful, width: 864, height: 1504 },
      notebook: { url: charactersAgentAlexNotebook, width: 864, height: 1504 },
      present: { url: charactersAgentAlexPresent, width: 864, height: 1504 },
      rrr: { url: charactersAgentAlexRrr, width: 864, height: 1504 },
      sheepish: { url: charactersAgentAlexSheepish, width: 864, height: 1504 },
      try: { url: charactersAgentAlexTry, width: 864, height: 1504 },
      wave: { url: charactersAgentAlexWave, width: 864, height: 1504 },
      whisper: { url: charactersAgentAlexWhisper, width: 864, height: 1504 },
      worried: { url: charactersAgentAlexWorried, width: 864, height: 1504 },
    },
    agentBuilder: {
      back: {
        backpackFront: { url: charactersAgentBuilderBackBackpackFront, width: 640, height: 985 },
        backpack: { url: charactersAgentBuilderBackBackpack, width: 640, height: 985 },
        capeFront: { url: charactersAgentBuilderBackCapeFront, width: 640, height: 985 },
        cape: { url: charactersAgentBuilderBackCape, width: 640, height: 985 },
        jetpackFront: { url: charactersAgentBuilderBackJetpackFront, width: 640, height: 985 },
        jetpack: { url: charactersAgentBuilderBackJetpack, width: 640, height: 985 },
      },
      body: {
        aBrown: { url: charactersAgentBuilderBodyABrown, width: 640, height: 985 },
        aDeep: { url: charactersAgentBuilderBodyADeep, width: 640, height: 985 },
        aLight: { url: charactersAgentBuilderBodyALight, width: 640, height: 985 },
        aMedium: { url: charactersAgentBuilderBodyAMedium, width: 640, height: 985 },
        aPorcelain: { url: charactersAgentBuilderBodyAPorcelain, width: 640, height: 985 },
        aTan: { url: charactersAgentBuilderBodyATan, width: 640, height: 985 },
        bBrown: { url: charactersAgentBuilderBodyBBrown, width: 640, height: 985 },
        bDeep: { url: charactersAgentBuilderBodyBDeep, width: 640, height: 985 },
        bLight: { url: charactersAgentBuilderBodyBLight, width: 640, height: 985 },
        bMedium: { url: charactersAgentBuilderBodyBMedium, width: 640, height: 985 },
        bPorcelain: { url: charactersAgentBuilderBodyBPorcelain, width: 640, height: 985 },
        bTan: { url: charactersAgentBuilderBodyBTan, width: 640, height: 985 },
        cBrown: { url: charactersAgentBuilderBodyCBrown, width: 640, height: 985 },
        cDeep: { url: charactersAgentBuilderBodyCDeep, width: 640, height: 985 },
        cLight: { url: charactersAgentBuilderBodyCLight, width: 640, height: 985 },
        cMedium: { url: charactersAgentBuilderBodyCMedium, width: 640, height: 985 },
        cPorcelain: { url: charactersAgentBuilderBodyCPorcelain, width: 640, height: 985 },
        cTan: { url: charactersAgentBuilderBodyCTan, width: 640, height: 985 },
        dBrown: { url: charactersAgentBuilderBodyDBrown, width: 640, height: 985 },
        dDeep: { url: charactersAgentBuilderBodyDDeep, width: 640, height: 985 },
        dLight: { url: charactersAgentBuilderBodyDLight, width: 640, height: 985 },
        dMedium: { url: charactersAgentBuilderBodyDMedium, width: 640, height: 985 },
        dPorcelain: { url: charactersAgentBuilderBodyDPorcelain, width: 640, height: 985 },
        dTan: { url: charactersAgentBuilderBodyDTan, width: 640, height: 985 },
        eBrown: { url: charactersAgentBuilderBodyEBrown, width: 640, height: 985 },
        eDeep: { url: charactersAgentBuilderBodyEDeep, width: 640, height: 985 },
        eLight: { url: charactersAgentBuilderBodyELight, width: 640, height: 985 },
        eMedium: { url: charactersAgentBuilderBodyEMedium, width: 640, height: 985 },
        ePorcelain: { url: charactersAgentBuilderBodyEPorcelain, width: 640, height: 985 },
        eTan: { url: charactersAgentBuilderBodyETan, width: 640, height: 985 },
      },
      eyewear: {
        glasses: { url: charactersAgentBuilderEyewearGlasses, width: 640, height: 985 },
        goggles: { url: charactersAgentBuilderEyewearGoggles, width: 640, height: 985 },
        mask: { url: charactersAgentBuilderEyewearMask, width: 640, height: 985 },
        shades: { url: charactersAgentBuilderEyewearShades, width: 640, height: 985 },
      },
      hair: {
        afro: { url: charactersAgentBuilderHairAfro, width: 640, height: 985 },
        bob: { url: charactersAgentBuilderHairBob, width: 640, height: 985 },
        braids: { url: charactersAgentBuilderHairBraids, width: 640, height: 985 },
        bun: { url: charactersAgentBuilderHairBun, width: 640, height: 985 },
        curls: { url: charactersAgentBuilderHairCurls, width: 640, height: 985 },
        long: { url: charactersAgentBuilderHairLong, width: 640, height: 985 },
        ponytail: { url: charactersAgentBuilderHairPonytail, width: 640, height: 985 },
        short: { url: charactersAgentBuilderHairShort, width: 640, height: 985 },
        spiky: { url: charactersAgentBuilderHairSpiky, width: 640, height: 985 },
        twists: { url: charactersAgentBuilderHairTwists, width: 640, height: 985 },
      },
      headgear: {
        beanieCover: { url: charactersAgentBuilderHeadgearBeanieCover, width: 640, height: 985 },
        beanie: { url: charactersAgentBuilderHeadgearBeanie, width: 640, height: 985 },
        capCover: { url: charactersAgentBuilderHeadgearCapCover, width: 640, height: 985 },
        cap: { url: charactersAgentBuilderHeadgearCap, width: 640, height: 985 },
        headset: { url: charactersAgentBuilderHeadgearHeadset, width: 640, height: 985 },
      },
      shoes: {
        boots: { url: charactersAgentBuilderShoesBoots, width: 640, height: 985 },
        sneakers: { url: charactersAgentBuilderShoesSneakers, width: 640, height: 985 },
      },
      suit: {
        field: { url: charactersAgentBuilderSuitField, width: 640, height: 985 },
        hoodie: { url: charactersAgentBuilderSuitHoodie, width: 640, height: 985 },
        labcoat: { url: charactersAgentBuilderSuitLabcoat, width: 640, height: 985 },
        stealth: { url: charactersAgentBuilderSuitStealth, width: 640, height: 985 },
        tech: { url: charactersAgentBuilderSuitTech, width: 640, height: 985 },
      },
    },
    agentRook: {
      disguised: { url: charactersAgentRookDisguised, width: 573, height: 583 },
      revealed: { url: charactersAgentRookRevealed, width: 580, height: 580 },
    },
    agent: {
      standing: { url: charactersAgentStanding, width: 420, height: 724 },
    },
    cipherCat: {
      disguised: { url: charactersCipherCatDisguised, width: 640, height: 838 },
      revealed: { url: charactersCipherCatRevealed, width: 640, height: 844 },
    },
    echoLynx: {
      disguised: { url: charactersEchoLynxDisguised, width: 619, height: 637 },
      revealed: { url: charactersEchoLynxRevealed, width: 516, height: 638 },
    },
    helperBunny: {
      clipboard: { url: charactersHelperBunnyClipboard, width: 640, height: 1031 },
      tablet: { url: charactersHelperBunnyTablet, width: 525, height: 616 },
    },
    mistyMole: {
      disguised: { url: charactersMistyMoleDisguised, width: 640, height: 597 },
      revealed: { url: charactersMistyMoleRevealed, width: 570, height: 495 },
    },
    novaOwl: {
      disguised: { url: charactersNovaOwlDisguised, width: 640, height: 650 },
      revealed: { url: charactersNovaOwlRevealed, width: 547, height: 581 },
    },
    scout: {
      celebrating: { url: charactersScoutCelebrating, width: 489, height: 520 },
      listening: { url: charactersScoutListening, width: 493, height: 510 },
      receiving: { url: charactersScoutReceiving, width: 522, height: 540 },
    },
    shadowFox: {
      disguised: { url: charactersShadowFoxDisguised, width: 640, height: 559 },
      happy: { url: charactersShadowFoxHappy, width: 640, height: 687 },
    },
  },
  coach: {
    l: { url: coachL, width: 512, height: 512 },
    mouthTeeth: { url: coachMouthTeeth, width: 512, height: 512 },
    mouth: { url: coachMouth, width: 512, height: 512 },
    rBunched: { url: coachRBunched, width: 512, height: 512 },
    rRetroflex: { url: coachRRetroflex, width: 512, height: 512 },
    tongueSides: { url: coachTongueSides, width: 512, height: 357 },
    w: { url: coachW, width: 512, height: 512 },
  },
  objects: {
    elevatorCab: { url: objectsElevatorCab, width: 384, height: 707 },
    targetWords: {
      acorn: { url: objectsTargetWordsAcorn, width: 332, height: 442 },
      beard: { url: objectsTargetWordsBeard, width: 384, height: 421 },
      chandelier: { url: objectsTargetWordsChandelier, width: 384, height: 514 },
      cheer: { url: objectsTargetWordsCheer, width: 384, height: 439 },
      codeCard: { url: objectsTargetWordsCodeCard, width: 384, height: 447 },
      crab: { url: objectsTargetWordsCrab, width: 384, height: 329 },
      crown: { url: objectsTargetWordsCrown, width: 384, height: 347 },
      dinosaur: { url: objectsTargetWordsDinosaur, width: 384, height: 514 },
      drum: { url: objectsTargetWordsDrum, width: 384, height: 386 },
      fire: { url: objectsTargetWordsFire, width: 339, height: 482 },
      frog: { url: objectsTargetWordsFrog, width: 384, height: 374 },
      grapes: { url: objectsTargetWordsGrapes, width: 384, height: 452 },
      guitar: { url: objectsTargetWordsGuitar, width: 384, height: 394 },
      popcorn: { url: objectsTargetWordsPopcorn, width: 382, height: 473 },
      rabbit: { url: objectsTargetWordsRabbit, width: 384, height: 419 },
      radio: { url: objectsTargetWordsRadio, width: 384, height: 389 },
      rain: { url: objectsTargetWordsRain, width: 384, height: 377 },
      rainbow: { url: objectsTargetWordsRainbow, width: 384, height: 244 },
      rat: { url: objectsTargetWordsRat, width: 384, height: 288 },
      red: { url: objectsTargetWordsRed, width: 384, height: 368 },
      rhino: { url: objectsTargetWordsRhino, width: 384, height: 354 },
      rice: { url: objectsTargetWordsRice, width: 384, height: 312 },
      ring: { url: objectsTargetWordsRing, width: 384, height: 429 },
      robin: { url: objectsTargetWordsRobin, width: 384, height: 404 },
      robot: { url: objectsTargetWordsRobot, width: 384, height: 387 },
      rocket: { url: objectsTargetWordsRocket, width: 384, height: 378 },
      rocks: { url: objectsTargetWordsRocks, width: 384, height: 306 },
      rope: { url: objectsTargetWordsRope, width: 384, height: 364 },
      square: { url: objectsTargetWordsSquare, width: 365, height: 365 },
      star: { url: objectsTargetWordsStar, width: 384, height: 368 },
      tornado: { url: objectsTargetWordsTornado, width: 384, height: 462 },
      train: { url: objectsTargetWordsTrain, width: 384, height: 327 },
      vampire: { url: objectsTargetWordsVampire, width: 383, height: 510 },
    },
  },
  props: {
    holoProjector: { url: propsHoloProjector, width: 1024, height: 487 },
  },
  ui: {
    buttons: {
      back: { url: uiButtonsBack, width: 256, height: 239 },
      micIdle: { url: uiButtonsMicIdle, width: 768, height: 768 },
      micListening: { url: uiButtonsMicListening, width: 768, height: 768 },
      settings: { url: uiButtonsSettings, width: 256, height: 246 },
    },
  },
} as const satisfies AssetTree;

/** Every image by its path under src/assets without extension, for data-driven content. */
export const imageByPath: Readonly<Record<string, ImageAsset>> = {
  'backgrounds/command-center-landscape': {
    url: backgroundsCommandCenterLandscape,
    width: 1672,
    height: 941,
  },
  'backgrounds/command-center-portrait': {
    url: backgroundsCommandCenterPortrait,
    width: 941,
    height: 1672,
  },
  'backgrounds/elevator-landscape': { url: backgroundsElevatorLandscape, width: 1672, height: 941 },
  'backgrounds/elevator-portrait': { url: backgroundsElevatorPortrait, width: 941, height: 1672 },
  'backgrounds/hq-hall': { url: backgroundsHqHall, width: 941, height: 1672 },
  'backgrounds/intro/room-landscape': {
    url: backgroundsIntroRoomLandscape,
    width: 1672,
    height: 941,
  },
  'backgrounds/intro/room-portrait': {
    url: backgroundsIntroRoomPortrait,
    width: 941,
    height: 1672,
  },
  'backgrounds/lab-landscape-bokeh': {
    url: backgroundsLabLandscapeBokeh,
    width: 1672,
    height: 941,
  },
  'backgrounds/lab-landscape': { url: backgroundsLabLandscape, width: 1672, height: 941 },
  'backgrounds/lab-portrait-bokeh': { url: backgroundsLabPortraitBokeh, width: 941, height: 1672 },
  'backgrounds/lab-portrait': { url: backgroundsLabPortrait, width: 941, height: 1672 },
  'brand/emblem': { url: brandEmblem, width: 1400, height: 537 },
  'brand/logo': { url: brandLogo, width: 1400, height: 244 },
  'characters/agent-alex/confide': { url: charactersAgentAlexConfide, width: 864, height: 1504 },
  'characters/agent-alex/hopeful': { url: charactersAgentAlexHopeful, width: 864, height: 1504 },
  'characters/agent-alex/notebook': { url: charactersAgentAlexNotebook, width: 864, height: 1504 },
  'characters/agent-alex/present': { url: charactersAgentAlexPresent, width: 864, height: 1504 },
  'characters/agent-alex/rrr': { url: charactersAgentAlexRrr, width: 864, height: 1504 },
  'characters/agent-alex/sheepish': { url: charactersAgentAlexSheepish, width: 864, height: 1504 },
  'characters/agent-alex/try': { url: charactersAgentAlexTry, width: 864, height: 1504 },
  'characters/agent-alex/wave': { url: charactersAgentAlexWave, width: 864, height: 1504 },
  'characters/agent-alex/whisper': { url: charactersAgentAlexWhisper, width: 864, height: 1504 },
  'characters/agent-alex/worried': { url: charactersAgentAlexWorried, width: 864, height: 1504 },
  'characters/agent-builder/back/backpack-front': {
    url: charactersAgentBuilderBackBackpackFront,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/back/backpack': {
    url: charactersAgentBuilderBackBackpack,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/back/cape-front': {
    url: charactersAgentBuilderBackCapeFront,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/back/cape': {
    url: charactersAgentBuilderBackCape,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/back/jetpack-front': {
    url: charactersAgentBuilderBackJetpackFront,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/back/jetpack': {
    url: charactersAgentBuilderBackJetpack,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/a-brown': {
    url: charactersAgentBuilderBodyABrown,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/a-deep': {
    url: charactersAgentBuilderBodyADeep,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/a-light': {
    url: charactersAgentBuilderBodyALight,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/a-medium': {
    url: charactersAgentBuilderBodyAMedium,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/a-porcelain': {
    url: charactersAgentBuilderBodyAPorcelain,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/a-tan': {
    url: charactersAgentBuilderBodyATan,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/b-brown': {
    url: charactersAgentBuilderBodyBBrown,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/b-deep': {
    url: charactersAgentBuilderBodyBDeep,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/b-light': {
    url: charactersAgentBuilderBodyBLight,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/b-medium': {
    url: charactersAgentBuilderBodyBMedium,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/b-porcelain': {
    url: charactersAgentBuilderBodyBPorcelain,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/b-tan': {
    url: charactersAgentBuilderBodyBTan,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/c-brown': {
    url: charactersAgentBuilderBodyCBrown,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/c-deep': {
    url: charactersAgentBuilderBodyCDeep,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/c-light': {
    url: charactersAgentBuilderBodyCLight,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/c-medium': {
    url: charactersAgentBuilderBodyCMedium,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/c-porcelain': {
    url: charactersAgentBuilderBodyCPorcelain,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/c-tan': {
    url: charactersAgentBuilderBodyCTan,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/d-brown': {
    url: charactersAgentBuilderBodyDBrown,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/d-deep': {
    url: charactersAgentBuilderBodyDDeep,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/d-light': {
    url: charactersAgentBuilderBodyDLight,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/d-medium': {
    url: charactersAgentBuilderBodyDMedium,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/d-porcelain': {
    url: charactersAgentBuilderBodyDPorcelain,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/d-tan': {
    url: charactersAgentBuilderBodyDTan,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/e-brown': {
    url: charactersAgentBuilderBodyEBrown,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/e-deep': {
    url: charactersAgentBuilderBodyEDeep,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/e-light': {
    url: charactersAgentBuilderBodyELight,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/e-medium': {
    url: charactersAgentBuilderBodyEMedium,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/e-porcelain': {
    url: charactersAgentBuilderBodyEPorcelain,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/body/e-tan': {
    url: charactersAgentBuilderBodyETan,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/eyewear/glasses': {
    url: charactersAgentBuilderEyewearGlasses,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/eyewear/goggles': {
    url: charactersAgentBuilderEyewearGoggles,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/eyewear/mask': {
    url: charactersAgentBuilderEyewearMask,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/eyewear/shades': {
    url: charactersAgentBuilderEyewearShades,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/hair/afro': {
    url: charactersAgentBuilderHairAfro,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/hair/bob': {
    url: charactersAgentBuilderHairBob,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/hair/braids': {
    url: charactersAgentBuilderHairBraids,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/hair/bun': {
    url: charactersAgentBuilderHairBun,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/hair/curls': {
    url: charactersAgentBuilderHairCurls,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/hair/long': {
    url: charactersAgentBuilderHairLong,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/hair/ponytail': {
    url: charactersAgentBuilderHairPonytail,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/hair/short': {
    url: charactersAgentBuilderHairShort,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/hair/spiky': {
    url: charactersAgentBuilderHairSpiky,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/hair/twists': {
    url: charactersAgentBuilderHairTwists,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/headgear/beanie-cover': {
    url: charactersAgentBuilderHeadgearBeanieCover,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/headgear/beanie': {
    url: charactersAgentBuilderHeadgearBeanie,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/headgear/cap-cover': {
    url: charactersAgentBuilderHeadgearCapCover,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/headgear/cap': {
    url: charactersAgentBuilderHeadgearCap,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/headgear/headset': {
    url: charactersAgentBuilderHeadgearHeadset,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/shoes/boots': {
    url: charactersAgentBuilderShoesBoots,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/shoes/sneakers': {
    url: charactersAgentBuilderShoesSneakers,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/suit/field': {
    url: charactersAgentBuilderSuitField,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/suit/hoodie': {
    url: charactersAgentBuilderSuitHoodie,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/suit/labcoat': {
    url: charactersAgentBuilderSuitLabcoat,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/suit/stealth': {
    url: charactersAgentBuilderSuitStealth,
    width: 640,
    height: 985,
  },
  'characters/agent-builder/suit/tech': {
    url: charactersAgentBuilderSuitTech,
    width: 640,
    height: 985,
  },
  'characters/agent-rook/disguised': { url: charactersAgentRookDisguised, width: 573, height: 583 },
  'characters/agent-rook/revealed': { url: charactersAgentRookRevealed, width: 580, height: 580 },
  'characters/agent/standing': { url: charactersAgentStanding, width: 420, height: 724 },
  'characters/cipher-cat/disguised': { url: charactersCipherCatDisguised, width: 640, height: 838 },
  'characters/cipher-cat/revealed': { url: charactersCipherCatRevealed, width: 640, height: 844 },
  'characters/echo-lynx/disguised': { url: charactersEchoLynxDisguised, width: 619, height: 637 },
  'characters/echo-lynx/revealed': { url: charactersEchoLynxRevealed, width: 516, height: 638 },
  'characters/helper-bunny/clipboard': {
    url: charactersHelperBunnyClipboard,
    width: 640,
    height: 1031,
  },
  'characters/helper-bunny/tablet': { url: charactersHelperBunnyTablet, width: 525, height: 616 },
  'characters/misty-mole/disguised': { url: charactersMistyMoleDisguised, width: 640, height: 597 },
  'characters/misty-mole/revealed': { url: charactersMistyMoleRevealed, width: 570, height: 495 },
  'characters/nova-owl/disguised': { url: charactersNovaOwlDisguised, width: 640, height: 650 },
  'characters/nova-owl/revealed': { url: charactersNovaOwlRevealed, width: 547, height: 581 },
  'characters/scout/celebrating': { url: charactersScoutCelebrating, width: 489, height: 520 },
  'characters/scout/listening': { url: charactersScoutListening, width: 493, height: 510 },
  'characters/scout/receiving': { url: charactersScoutReceiving, width: 522, height: 540 },
  'characters/shadow-fox/disguised': { url: charactersShadowFoxDisguised, width: 640, height: 559 },
  'characters/shadow-fox/happy': { url: charactersShadowFoxHappy, width: 640, height: 687 },
  'coach/l': { url: coachL, width: 512, height: 512 },
  'coach/mouth-teeth': { url: coachMouthTeeth, width: 512, height: 512 },
  'coach/mouth': { url: coachMouth, width: 512, height: 512 },
  'coach/r-bunched': { url: coachRBunched, width: 512, height: 512 },
  'coach/r-retroflex': { url: coachRRetroflex, width: 512, height: 512 },
  'coach/tongue-sides': { url: coachTongueSides, width: 512, height: 357 },
  'coach/w': { url: coachW, width: 512, height: 512 },
  'objects/elevator-cab': { url: objectsElevatorCab, width: 384, height: 707 },
  'objects/target-words/acorn': { url: objectsTargetWordsAcorn, width: 332, height: 442 },
  'objects/target-words/beard': { url: objectsTargetWordsBeard, width: 384, height: 421 },
  'objects/target-words/chandelier': { url: objectsTargetWordsChandelier, width: 384, height: 514 },
  'objects/target-words/cheer': { url: objectsTargetWordsCheer, width: 384, height: 439 },
  'objects/target-words/code-card': { url: objectsTargetWordsCodeCard, width: 384, height: 447 },
  'objects/target-words/crab': { url: objectsTargetWordsCrab, width: 384, height: 329 },
  'objects/target-words/crown': { url: objectsTargetWordsCrown, width: 384, height: 347 },
  'objects/target-words/dinosaur': { url: objectsTargetWordsDinosaur, width: 384, height: 514 },
  'objects/target-words/drum': { url: objectsTargetWordsDrum, width: 384, height: 386 },
  'objects/target-words/fire': { url: objectsTargetWordsFire, width: 339, height: 482 },
  'objects/target-words/frog': { url: objectsTargetWordsFrog, width: 384, height: 374 },
  'objects/target-words/grapes': { url: objectsTargetWordsGrapes, width: 384, height: 452 },
  'objects/target-words/guitar': { url: objectsTargetWordsGuitar, width: 384, height: 394 },
  'objects/target-words/popcorn': { url: objectsTargetWordsPopcorn, width: 382, height: 473 },
  'objects/target-words/rabbit': { url: objectsTargetWordsRabbit, width: 384, height: 419 },
  'objects/target-words/radio': { url: objectsTargetWordsRadio, width: 384, height: 389 },
  'objects/target-words/rain': { url: objectsTargetWordsRain, width: 384, height: 377 },
  'objects/target-words/rainbow': { url: objectsTargetWordsRainbow, width: 384, height: 244 },
  'objects/target-words/rat': { url: objectsTargetWordsRat, width: 384, height: 288 },
  'objects/target-words/red': { url: objectsTargetWordsRed, width: 384, height: 368 },
  'objects/target-words/rhino': { url: objectsTargetWordsRhino, width: 384, height: 354 },
  'objects/target-words/rice': { url: objectsTargetWordsRice, width: 384, height: 312 },
  'objects/target-words/ring': { url: objectsTargetWordsRing, width: 384, height: 429 },
  'objects/target-words/robin': { url: objectsTargetWordsRobin, width: 384, height: 404 },
  'objects/target-words/robot': { url: objectsTargetWordsRobot, width: 384, height: 387 },
  'objects/target-words/rocket': { url: objectsTargetWordsRocket, width: 384, height: 378 },
  'objects/target-words/rocks': { url: objectsTargetWordsRocks, width: 384, height: 306 },
  'objects/target-words/rope': { url: objectsTargetWordsRope, width: 384, height: 364 },
  'objects/target-words/square': { url: objectsTargetWordsSquare, width: 365, height: 365 },
  'objects/target-words/star': { url: objectsTargetWordsStar, width: 384, height: 368 },
  'objects/target-words/tornado': { url: objectsTargetWordsTornado, width: 384, height: 462 },
  'objects/target-words/train': { url: objectsTargetWordsTrain, width: 384, height: 327 },
  'objects/target-words/vampire': { url: objectsTargetWordsVampire, width: 383, height: 510 },
  'props/holo-projector': { url: propsHoloProjector, width: 1024, height: 487 },
  'ui/buttons/back': { url: uiButtonsBack, width: 256, height: 239 },
  'ui/buttons/mic-idle': { url: uiButtonsMicIdle, width: 768, height: 768 },
  'ui/buttons/mic-listening': { url: uiButtonsMicListening, width: 768, height: 768 },
  'ui/buttons/settings': { url: uiButtonsSettings, width: 256, height: 246 },
};
